module.exports = __webpack_public_path__ + "static/media/992049.0a1990ac.png";